import { css } from 'styled-components';

type GradientMap = {
  [key: string]: string;
};

type Theme = {
  colors: {
    gradients: {
      history: string;
      portuguese: string;
      art: string;
      science: string;
      geography: string;
      math: string;
    };
  };
};

const getGradientType = (
  type: string,
  theme: Theme,
  isActive?: boolean | undefined,
) => {
  const gradientMap: GradientMap = {
    history: theme.colors.gradients.history,
    portuguese: theme.colors.gradients.portuguese,
    art: theme.colors.gradients.art,
    science: theme.colors.gradients.science,
    geography: theme.colors.gradients.geography,
    math: theme.colors.gradients.math,
  };

  let background;

  if (isActive) {
    background = 'linear-gradient(90deg, gray 0%, white 100%)';
  } else {
    background = gradientMap[type];
  }

  return css`
    background: ${background};
  `;
};

export default getGradientType;
